<template>
  <div class="ep-auth-page">
    <div class="page-title">用户授权</div>
    <div class="content-body">
      <div class="app-info-box">
        <img :src="appDetail.app_img_url" alt="" class="app-info-img">
        <img src="../../assets/img/control/bothway_arrow.png" alt="" class="app-info-arrow">
        <img :src="appTypeIcon" alt="" class="app-info-img">
      </div>
      <div class="tips-small">
        您正在授权应用
        <span class="text-warning">{{ appDetail.app_name }}</span>
        <span v-if="isMaster" class="env-box master">(正式)</span>
        <span v-if="isSandbox" class="env-box sandbox">(沙箱)</span>
        获取您
        <span class="text-warning">{{ appTypeName }}</span>
        账户身份信息及使用您的货拉拉账户为您提供相关服务。

      </div>
      <div class="tips-small">应用将获取您的账户如下操作权限：</div>
      <div class="power-list-box">
        <div class="power-item" v-for="item in appPowerList" :key="item">
          <el-checkbox :checked="true" disabled>{{ item }}</el-checkbox>
        </div>
      </div>
      <el-form ref="anthForm"
               class="form-box large-form"
               :model="editInfo"
               :rules="rules"
               label-width="0">
        <el-form-item label="" prop="auth_mobile">
          <el-input v-model="editInfo.auth_mobile" maxlength="11" clearable :placeholder="mobilePlaceholder">
            <i slot="prefix" class="input-icon input-icon-phone"></i>
          </el-input>
        </el-form-item>
        <el-form-item label="" prop="captcha_code" :rules="rules.code" class="input-code-item">
          <el-input v-model="editInfo.captcha_code" maxlength="4" clearable placeholder="图片验证码">
            <i slot="prefix" class="input-icon input-icon-shield"></i>
          </el-input>
          <div class="input-code-box">
            <img :src="codeImg" class="pointer" @click="getImgCode" v-if="codeImg"/>
          </div>
        </el-form-item>
        <el-form-item label="" prop="auth_code" class="input-code-item">
          <el-input v-model="editInfo.auth_code" maxlength="4" clearable placeholder="请输入验证码">
            <i slot="prefix" class="input-icon input-icon-shield"></i>
          </el-input>
          <div class="input-code-box text-warning pointer" @click="getSmsCode">
            {{ smsTimer === 0 ? '获取验证码' : `${smsTimer}s后重试` }}
          </div>
        </el-form-item>
        <div v-if="!hideRegister" class="account-tips-box">
          <el-checkbox v-model="editInfo.is_create_user" :true-label="1" :false-label="0">
            <span class="account-tips">创建账户（当账户不存在时）</span>
          </el-checkbox>
        </div>
        <div v-if="hideRegister">
          <label>tip: 企业员工账号请先在企业版APP/PC端进行企业账户绑定</label>
        </div>
      </el-form>
      <div style="padding-top: 10px">
        <el-button class="submit-btn" @click="funAuth">确认授权</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {sandboxRequest} from "../../axios/sandboxRequest";
import {ServerInterface} from "../../axios/ServerInterface";

export default {
  name: 'controlEpAuth',
  data() {
    let phoneCheck = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号码'));
      } else if (value && !this.$config.regCommon.phone.test(value)) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    };
    return {
      tip: '授权成功，即将跳转...',
      isSandbox: false,
      isMaster: true,
      epIcon: require('../../assets/img/index/icon_ep.png'),
      userIcon: require('../../assets/img/index/icon_user.png'),
      appKey: '', // 应用唯一key
      responseType: '', // 'code'
      redirectUri: '', // 回调地址
      appDetail: {},
      appTypeIcon: '', // 应用类型图标
      appTypeName: '', // 应用类型
      appPowerList: [], // 应用所需权限列表
      editInfo: {
        auth_mobile: '',
        auth_code: '',
        captcha_code: '',
        is_create_user: 1, // 是否勾选创建用户0:不勾选 1:勾选
      },
      hideRegister: 0,
      mobilePlaceholder: '请输入货拉拉手机号',
      smsTimer: 0, // 短信验证码计时器
      codeImg: '',
      codeKey: '',
      rules: {
        auth_mobile: [
          {validator: phoneCheck, trigger: 'blur'}
        ],
        auth_code: [
          {required: true, message: '请输入验证码', trigger: 'blur'}
        ],
      }
    }
  },
  mounted() {
    this.isSandbox = this.$route.query.isSandbox === 'true';
    this.isMaster = !this.isSandbox;
    this.appKey = this.$route.query.client_id;
    this.responseType = this.$route.query.response_type;
    this.redirectUri = this.$route.query.redirect_uri ? decodeURI(this.$route.query.redirect_uri) : '';
    this.editInfo.auth_mobile = this.$route.query.auth_mobile || '';
    this.paramsCheck();
    this.getAppDetail();
    this.getImgCode();
  },
  computed: {
    server() {
      let sandbox = this.isSandbox ? 1 : 0
      return new ServerInterface(sandbox);
    },
  },
  methods: {
    getTip() {
      let tip = this.$route.query.tip;
      if (tip !== undefined) {
        if (this.check(tip)) {
          this.tip = tip;
        }
      }
    },
    check(str) {
      return !(new RegExp("[`#$^&*<>]").test(str));
    },
    envIsOpen() { // 沙箱环境是否开启
      sandboxRequest.showSandboxEnv().then(res => {
        this.showSandboxSwitch = res.ret === 0 && res.data;
      })
    },

    registerEntrance() {
      // 企业App 不允许注册
      let hide = this.appDetail.type_account === 2;
      this.editInfo.is_create_user = !hide;
      this.hideRegister = hide;
      return hide;
    },
    paramsCheck() {
      let errorArr = [];
      if (this.responseType !== 'code') {
        errorArr.push('url参数response_type错误，必须为"code"');
      }
      if (!this.appKey) {
        errorArr.push('url参数client_id缺失');
      }
      if (!this.redirectUri) {
        errorArr.push('url参数redirect_uri缺失');
      }
      if (errorArr.length) {
        this.$confirm(`${errorArr.join('；')}。请检查~`, '', {
          confirmButtonText: '我知道了',
          type: 'warning',
          showCancelButton: false,
          showClose: false,
        }).then(() => {
        })
            .catch(() => {
            });
        return false;
      }
      return true;
    },
    // 获取应用详情
    getAppDetail() {
      this.server.post("/ajax/control/panel/app/base", {
        app_key: this.appKey
      }).then(res => {
        this.appDetail = res.data.data;
        if (this.appDetail.type_account === 1) {
          this.appTypeIcon = this.userIcon;
          this.appTypeName = '货拉拉APP';
          this.appPowerList = ['下单及取消订单', '添加小费', '查看订单详情', '支付账单', '账单申诉', '查询历史订单记录']
          this.mobilePlaceholder = '请输入货拉拉手机号'
        }
        if (this.appDetail.type_account === 2) {
          this.appTypeIcon = this.epIcon;
          this.appTypeName = '货拉拉企业版APP';
          this.appPowerList = ['下单及取消订单', '添加小费', '查看订单详情', '支付账单', '账单申诉', '查询历史订单记录']
          this.mobilePlaceholder = '请输入货拉拉企业版手机号'
        }
        this.registerEntrance();
      });
    },

    // 获取图片验证码
    getImgCode() {
      this.server.get("/ajax/common/interface/captcha/get", {
        params: {
          type: 2 // 1为注册; 2为登陆; 3为忘记密码
        }
      }).then(res => {
        this.codeImg = res.data.data.img
        this.codeKey = res.data.data.key
      })
    },

    // 获取短信验证码
    getSmsCode() {
      if (!this.paramsCheck()) {
        return;
      }
      if (this.isLoading || this.smsTimer !== 0) {
        return;
      }
      this.$refs.anthForm.validateField('auth_mobile', error => {
        if (!error) {
          this.showCommonLoading();
          this.server.post("/ajax/control/panel/app/auth/code", {
            auth_mobile: this.editInfo.auth_mobile,
            client_id: this.appKey,
            captcha_key: this.codeKey,
            captcha_code: this.editInfo.captcha_code,
          }).then(res => {
            this.hideCommonLoading();
            if (res.data.ret === 0) {
              this.$message.success('短信验证码发送成功');
              this.setSmsTimer();
            }
          }).catch(e => {
            this.hideCommonLoading();
          });
        }
      })
    },
    // 设置短信验证码获取倒计时
    setSmsTimer() {
      this.smsTimer = 60;
      let timerItem = setInterval(() => {
        if (this.smsTimer === 0) {
          clearInterval(timerItem);
        } else {
          this.smsTimer--;
        }
      }, 1000)
    },
    // 确认授权
    funAuth() {
      if (!this.paramsCheck()) {
        return;
      }
      if (this.isLoading) {
        return;
      }
      this.$refs.anthForm.validate(valid => {
        if (valid) {
          this.showCommonLoading();
          this.server.post("/ajax/control/panel/app/auth/add", {
            ...this.editInfo,
            response_type: this.responseType,
            client_id: this.appKey,
            redirect_uri: this.redirectUri,
          }).then(res => {
            this.hideCommonLoading();
            if (res.data.ret === 0) {
              this.getTip();
              this.$message.success(this.tip);
              let link = this.appDetail.call_back.indexOf('?') === -1 ? '?' : '&';
              let origin = this.redirectUri.indexOf('http') === -1 ? `//${this.redirectUri}` : this.redirectUri;
              setTimeout(() => {
                window.location.replace(`${origin}${link}code=${res.data.data.code}`);
              }, 2000)
            }
          }).catch(e => {
            this.hideCommonLoading();
          });
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ep-auth-page {
  width: 550px;
  padding: 30px 0 30px;
  margin: 0 auto;
}

.page-title {
  width: 100%;
  height: 32px;
  line-height: 32px;
  font-size: 24px;
  color: #212121;
  text-align: center;
}

.content-body {
  width: 100%;
  height: 680px;
  padding: 50px 60px;
  margin-top: 30px;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
}

.app-info-box {
  width: 100%;
  height: 80px;
  text-align: center;
  margin-bottom: 20px;

  .app-info-img {
    width: 80px;
    height: 80px;
    vertical-align: middle;
    border: 1px solid #f7f7f7;
  }

  .app-info-arrow {
    width: 60px;
    height: 30px;
    margin: 0 10px;
    vertical-align: middle;
  }
}

.tips-small {
  font-size: 16px;
  line-height: 24px;
  padding-left: 12px;
  position: relative;

  &:before {
    content: '*';
    position: absolute;
    top: 1px;
    left: 0;
    color: #666;
  }
}

.power-list-box {
  padding-left: 16px;
  margin-top: 2px;

  .power-item {
    display: inline-block;
    width: 40%;
  }

  /deep/ .el-checkbox__input.is-disabled + span.el-checkbox__label {
    color: #606266;
  }
}

.form-box {
  margin-top: 34px;
}

.account-tips-box {
  margin-left: 1px;
  margin-top: -6px;
}

.account-tips {
  height: 14px;
  font-size: 13px;
  line-height: 14px;
  color: #606266;
}

.submit-btn {
  width: 100%;
  height: 40px;
  background: #F16222;
  font-size: 14px;
  color: #fff;
  border: none;
  margin-top: 5px;
  font-weight: normal;

  &.disabled {
    background: rgba(241, 98, 34, .35);
  }
}
</style>

<style lang="scss">
/*对h5的兼容*/
@media screen and (max-width: 600px) {
  .h5-components {
    .ep-auth-page {
      width: 100%;
      padding: 20px 0 20px;

      .page-title {
        height: 26px;
        line-height: 26px;
        font-size: 20px;
      }

      .content-body {
        height: auto;
        margin-top: 24px;
        padding: 0 20px;
        box-shadow: none;
      }

      .app-info-box {
        height: 60px;
        margin-bottom: 18px;

        .app-info-img {
          width: 60px;
          height: 60px;
        }

        .app-info-arrow {
          width: 40px;
          height: 20px;
        }
      }

      .power-item {
        width: 46%;
      }

      .tips-small {
        font-size: 14px;
        line-height: 22px;
      }

      .form-box {
        margin-top: 24px;
      }

      .el-form-item {
        margin-bottom: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/control/ep-auth.vue